module.exports = __webpack_public_path__ + "6b707c61/img/trash-icon.ff8201c7.svg";